import DealTermsModal from './DealTermsModal';
export default DealTermsModal;